import { Document, JobItem } from '@kanda-libs/ks-frontend-services';

import { calculateItemTotal } from 'utils';

export interface JobKandaQuoteLineItem {
  type: 'kanda';
  title: string;
  price: number;
  description?: string;
}

export interface JobCustomQuoteLineItem {
  type: 'custom';
  title: string;
  price: number;
  id?: string;
}

export type JobQuoteLineItem = JobKandaQuoteLineItem | JobCustomQuoteLineItem;

export const formatCustomItem = (
  item: JobItem,
  doc: Document,
): JobCustomQuoteLineItem => {
  const price = calculateItemTotal(
    item.quantity,
    item.price.amount,
    item.vat_rate,
    item.vat.amount,
  );
  return {
    type: 'custom',
    title: doc.name,
    price: price.totalIncVat,
    id: doc.id,
  };
};

export const formatKandaItem = (item: JobItem): JobKandaQuoteLineItem => {
  const price = calculateItemTotal(
    item.quantity,
    item.price.amount,
    item.vat_rate,
    item.vat.amount,
  );
  return {
    type: 'kanda',
    title: item.title,
    price: price.totalIncVat,
    description: item.description,
  };
};
